module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAFASURBVEiJxdWhbsMwEIDh01RQUDBQUBCQB+kjpNLAHmOgj1GpYC8yXlCQSS0ZGBrYQwwUBAxs0j/Qq+ZdfYmTudtJkSL77r7WcRyRHgFMgBrYAZM+tX2RHfChV37MILd65cUsEoznwzwkOwZUHhLB3JxUbJoj5/8CWAJvwLUZL4F7fY9qvS9NzlRr71IQgAdgFIxXQMN5NEAV5I20FmDZFykdJMTKJMxDdG7dgpxibWrOsTZE5+sEqI7U/cSAA/AOFM6SDoK0ttDehysRWYjIp4hsgVkk/znWxMRTBJmJyFZ7L06Dc44P9dVipG2GwiLaqwHm9he0YUnbuxOJYC/A2MwVwIrvF3YV+SfjTsRgGwacxhxP+00n4hTHNojN+d2hCtzwF58JXYq91yhA9kOWOgnLinjYRRAHuwxisMchyBd/HF0CZCobFgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hk-video/holder.png
// module id = kMQX
// module chunks = 1